import React, { HTMLAttributes } from 'react'
import styled, { css } from 'styled-components'
import { STypographyDefault, STypographyLarge } from '@components/Typography'
import Box from '@components/Box'
import { above, below } from '@styles/mixins/breakpoints'
import { links, primaryLinks } from '../data'

interface ILink extends HTMLAttributes<HTMLAnchorElement> {
  href?: string
}

const Link: React.FC<ILink> = (props) => <STypographyDefault as="a" color="graphite" {...props} />
const PrimaryLink: React.FC<ILink> = (props) => <STypographyLarge as="a" color="graphite" fontWeight="600" {...props} />

const SPrimaryLink = styled(PrimaryLink)`
  ${below('xl')(css`
    border-bottom: 1px solid ${({ theme }) => theme.colors.middleGray};
    padding-bottom: 12px;
    margin-bottom: 12px;
  `)}
`
const SLink = styled(Link)``

const SColumn = styled(Box)`
  width: 30%;
  ${SPrimaryLink}:not(:last-child) {
    margin-bottom: 22px;
  }

  ${SLink}:not(:last-child) {
    margin-bottom: 24px;
  }
`

const SMenu = styled.div`
  display: flex;
`

const SLeft = styled.div`
  width: 60%;
  display: flex;
  margin-right: 8%;

  ${SColumn}:last-child {
    margin-right: 5%;
  }

  ${below('xl')(css`
    display: none;
  `)}
`

const SRight = styled(SColumn)`
  width: 100%;
  ${above('xl')(css`
    width: 32%;
  `)}
`

const Menu: React.FC = () => (
  <SMenu>
    <SLeft>
      {links.map((column, i) => {
        return (
          <SColumn key={i}>
            {column.map((link, i) => {
              const isFirst = i === 0
              const { name, href, targetBlank = true } = link
              const props = {
                key: i,
                children: name,
                href: href,
                target: targetBlank ? '_blank' : '_self',
              }
              return isFirst ? <SPrimaryLink {...props} /> : <SLink {...props} />
            })}
          </SColumn>
        )
      })}
    </SLeft>
    <SRight>
      {primaryLinks.map((link, i) => {
        const { name, href, targetBlank = true } = link
        const props = {
          key: i,
          children: name,
          href: href,
          target: targetBlank ? '_blank' : '_self',
        }

        return <SPrimaryLink {...props} />
      })}
    </SRight>
  </SMenu>
)

export default Menu
